import { createContext } from 'react';

//TODO :Ask why const CurrentUserContext starts with uppercase
const CurrentUserContext = createContext();

export default CurrentUserContext;
